import React, { useState, useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { startCase } from 'lodash'

import { SearchableDropdown } from '@/components/dropdowns/SearchableDropdown'
import { BasicModal } from '@/components/layout/modals/BasicModal'
import { fetchScorecardsByOrg } from '@/reducers/scorecards/scorecards.actions'
import { scoreCopilotScorecard } from '@/reducers/scorecards/scores.actions'
import { Button } from '@/components/buttons/Button'

export const ScoreForScorecard = ({
  callId,
  callType = 'call',
  organizationId,
  isDisabled,
  disabledTooltip,
}) => {
  const [newScoreScorecardModalOpen, setScoreScorecardModalOpen] = useState(false)
  const [selectedScorecardUuid, setSelectedScorecardUuid] = useState(null)
  const { data, loading } = useSelector((state) => state.scorecards)
  const dispatch = useDispatch()

  const scorecardOptions = (data.scorecardConfigs || [])
    .filter(
      (scorecard) =>
        scorecard?.active === true &&
        scorecard?.deleted === false &&
        scorecard?.call_type === callType
    )
    .map((scorecard) => ({ key: scorecard?.uuid, label: scorecard?.name, value: scorecard?.uuid }))

  const selectedScorecard = data.scorecardConfigs.find(
    (scorecard) => scorecard.uuid === selectedScorecardUuid
  )

  const handleCloseScoreScorecardModal = async () => {
    setScoreScorecardModalOpen(false)
    setSelectedScorecardUuid(null)
  }

  const handleOpenScoreScorecardModal = async (scorecardUuid) => {
    setSelectedScorecardUuid(scorecardUuid)
    setScoreScorecardModalOpen(true)
  }

  const handleSubmitScorecard = async () => {
    dispatch(scoreCopilotScorecard(organizationId, [callId], selectedScorecard.id))
    await handleCloseScoreScorecardModal()
  }

  useEffect(() => {
    if (organizationId) {
      dispatch(fetchScorecardsByOrg(organizationId, 'copilot'))
    }
  }, [])

  return (
    <>
      <div className="flex-align-center medium-gap">
        <SearchableDropdown
          buttonLabel={`Score ${startCase(callType)}`}
          buttonProps={{ small: true }}
          inputProps={{ placeholder: 'Search...' }}
          options={scorecardOptions}
          loading={loading.scorecard}
          placement="bottom-end"
          handleSelect={handleOpenScoreScorecardModal}
          isDisabled={isDisabled}
          disabledTooltip={disabledTooltip}
          dataTestId="scorecard"
        />
      </div>

      {newScoreScorecardModalOpen && (
        <BasicModal
          data-testid="score-scorecard-modal"
          title={`Rescore ${startCase(callType)} Using: "${selectedScorecard?.name}" Scorecard`}
          onClose={handleCloseScoreScorecardModal}
          show={newScoreScorecardModalOpen}
          size="tiny"
        >
          <div>
            <p>
              Resubmitting this {callType} bypasses eligibility settings{' '}
              {callType === 'call' ? 'and audio quality checks' : ''}, which may lead to inaccurate
              scores. Existing scores will be replaced, and this action counts toward your Quality
              quota.
            </p>
            <p>Are you sure you want to continue?</p>
            <div className="modal-footer">
              <Button
                data-testid="score-scorecard-cancel-button"
                disabled={loading.scorecardConfigs}
                loading={loading.scorecardConfigs}
                small
                onClick={handleCloseScoreScorecardModal}
              >
                No, Cancel
              </Button>
              <Button
                data-testid="score-scorecard-button"
                disabled={loading.scorecardConfigs || isDisabled}
                disabledTooltip={disabledTooltip}
                loading={loading.scorecardConfigs}
                brand
                small
                onClick={handleSubmitScorecard}
              >
                Yes, Proceed
              </Button>
            </div>
          </div>
        </BasicModal>
      )}
    </>
  )
}
